import { SearchRequestInstrumentation } from 'owa-search-service';
import addSearchRequestInstrumentationMutator from '../mutators/addSearchRequestInstrumentationMutator';
import ensureLoggerInitialized from '../logger/diagnosticsLogger';

export default function addSearchRequestInstrumentation(
    searchRequestInstrumentation: SearchRequestInstrumentation
) {
    // Push instrumentation to store (for email report)
    addSearchRequestInstrumentationMutator(searchRequestInstrumentation);

    // Initialize the diagnostics logger for diagnostics panel
    ensureLoggerInitialized();
}
